export default __webpack_public_path__ + "static/media/O-081.2f466a57.png";